export default __webpack_public_path__ + "static/16-f2e1799a624f0a459db4382fe3d4c33d.webp";